import { constRoutes as dynamicRoutes } from "@/router";
export function getActiveRoute(activename,routes){
            let myRoutePath=[]
            stop:
            for(let i=0;i<routes.length;i++){
                if(routes[i].name==activename) {
                    myRoutePath.push(routes[i].title)
                    break;
                }
                if(routes[i].hasChildren){
                     for(let j=0;j<routes[i].children.length;j++){
                         if(routes[i].children[j].name==activename){
                            myRoutePath.push(routes[i].title) 
                            myRoutePath.push(routes[i].children[j].title)
                            break stop;
                         }
                     }
                }
            }
            return myRoutePath
}

export function getAllRoutes(){
    let validRoutes=[]
    for(let i=0;i<dynamicRoutes.length;i++){
        if(dynamicRoutes[i]["icon"]!='' && dynamicRoutes[i]['icon']!=undefined && dynamicRoutes[i]["icon"]!=null){
            validRoutes.push(dynamicRoutes[i])
        }
    }
    return validRoutes
}